const propStateMapping = {
    itemsPerPage: (request, state) => request.setRecommendationsLimit(state.itemsPerPage),
};
export default propStateMapping;
